<template>
    <div class="body_main">
        <div class="body_bd">
            <!-- 今日预约统计面板 -->
            <div class="today_panel">
                <div class="today_panel_left">
                    <div class="today_panel_icon">
                        <el-icon size="28"><Calendar /></el-icon>
                    </div>
                    <div class="today_panel_title">
                        <div class="today_main_title">今日预约</div>
                        <div class="today_sub_title">{{ todayLabel }}</div>
                    </div>
                </div>
                <div class="today_panel_right">
                    <div class="stat_card stat_card_total" :class="{ stat_card_active: !queryParams.reStatus && !queryParams.isFree }" @click="filterByStatus('')">
                        <div class="stat_card_icon"><el-icon size="20"><Calendar /></el-icon></div>
                        <div class="stat_card_info"><span class="stat_num">{{ statData.total }}</span><span class="stat_label">总预约数</span></div>
                    </div>
                    <div class="stat_card stat_card_wait_sign" :class="{ stat_card_active: queryParams.reStatus === '8' }" @click="filterByStatus('8')">
                        <div class="stat_card_icon"><el-icon size="20"><Clock /></el-icon></div>
                        <div class="stat_card_info"><span class="stat_num">{{ statData.waitSign }}</span><span class="stat_label">待签到</span></div>
                    </div>
                    <div class="stat_card stat_card_wait_visit" :class="{ stat_card_active: queryParams.reStatus === '5' }" @click="filterByStatus('5')">
                        <div class="stat_card_icon"><el-icon size="20"><UserFilled /></el-icon></div>
                        <div class="stat_card_info"><span class="stat_num">{{ statData.waitVisit }}</span><span class="stat_label">待就诊</span></div>
                    </div>
                    <div class="stat_card stat_card_visiting" :class="{ stat_card_active: queryParams.reStatus === '6' }" @click="filterByStatus('6')">
                        <div class="stat_card_icon"><el-icon size="20"><FirstAidKit /></el-icon></div>
                        <div class="stat_card_info"><span class="stat_num">{{ statData.visiting }}</span><span class="stat_label">就诊中</span></div>
                    </div>
                    <div class="stat_card stat_card_done" :class="{ stat_card_active: queryParams.reStatus === '2' }" @click="filterByStatus('2')">
                        <div class="stat_card_icon"><el-icon size="20"><CircleCheck /></el-icon></div>
                        <div class="stat_card_info"><span class="stat_num">{{ statData.done }}</span><span class="stat_label">已完成</span></div>
                    </div>
                    <div class="stat_card stat_card_cancel" :class="{ stat_card_active: queryParams.isFree === '1' }" @click="filterByStatus('', '1')">
                        <div class="stat_card_icon"><el-icon size="20"><CircleClose /></el-icon></div>
                        <div class="stat_card_info"><span class="stat_num">{{ statData.cancel }}</span><span class="stat_label">已取消/失效</span></div>
                    </div>
                </div>
            </div>

            <!-- 搜索 -->
            <el-form class="search_con" :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
                <el-form-item label="预约人">
                    <el-input
                        v-model="queryParams.cardPatientName"
                        placeholder="预约人（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input
                        v-model="queryParams.cardPatientPhone"
                        placeholder="手机号（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="预约单号">
                    <el-input
                        v-model="queryParams.reSerialNo"
                        placeholder="预约单号（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" @click="getTodayReservationListInfo()">搜索</el-button>
                    <el-button icon="Refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格 -->
            <div class="table_bd">
                <el-table
                    ref="multipleTable"
                    v-loading="tableLoading"
                    :data="tableData"
                    :max-height="tableHeight"
                    fit
                    table-layout="auto"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column type="index" label="序号" width="50"> </el-table-column>
                    <el-table-column
                        prop="reSerialNo"
                        label="预约单号"
                        min-width="120">
                    </el-table-column>
                    <el-table-column
                        label="预约人"
                        min-width="150">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image class="elImage" :src="scope.row.avatar"></el-image>
                                <div class="base_info">
                                    <span style="font-size: 16px; font-weight: 600; line-height: 24px">{{ scope.row.cardPatientName }}</span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{ scope.row.sexText }}  {{ scope.row.age }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人手机号"
                        min-width="120">
                        <template #default="scope">
                            <span>{{ scope.row.cardPatientPhone === null ? '---' : scope.row.cardPatientPhone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约时间"
                        min-width="180">
                        <template #default="scope">
                            <span style="font-size: 14px; font-weight: 600">{{ scope.row.reTime === null ? '---' : scope.row.reTime }} {{scope.row.reTimeTypeText}}{{ (scope.row.queueSeq || scope.row.reNo) ? (scope.row.queueSeq || scope.row.reNo) + '号' : '' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单状态"
                        min-width="100">
                        <template #default="scope">
                            <el-tag
                                :type="scope.row.reStatus === '5' ? 'success' : scope.row.reStatus === '6' ? '' :
                                scope.row.reStatus === '7' ? 'danger' : scope.row.reStatus === '8' ? 'warning' :
                                scope.row.reStatus === '4' ? 'info' : scope.row.reStatus === '3' ? 'danger' :
                                scope.row.reStatus === '1' ? 'danger' : ''"
                                disable-transitions>{{ scope.row.reStatusText }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约医生"
                        min-width="110">
                        <template #default="scope">
                            <span>{{ scope.row.doctorName === null ? '---' : scope.row.doctorName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="门诊科室"
                        min-width="110">
                        <template #default="scope">
                            <span>{{ scope.row.odName === null ? '---' : scope.row.odName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单类型"
                        min-width="100">
                        <template #default="scope">
                            <el-tag :type="scope.row.visitType === null || scope.row.visitType === '初诊'?'success':'warning'" disable-transitions>
                                {{ scope.row.visitType === null ? '初诊' : scope.row.visitType }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="创建时间"
                        min-width="150">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="180">
                        <template #default="scope">
                            <el-button type="warning" size="small" @click="handleSign(scope.row)" v-if="scope.row.reStatus === '8'">签到</el-button>
                            <el-button type="success" size="small" @click="openMedical(scope.row)" v-if="scope.row.reStatus === '5'">接诊</el-button>
                            <el-button type="info" size="small" disabled v-if="scope.row.reStatus !== '5' && scope.row.reStatus !== '8'">接诊</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import todayreservation from "@/assets/scripts/todayreservation/index";

export default todayreservation;
</script>

<style scoped>
.today_panel {
    display: flex;
    align-items: stretch;
    background: #fff;
    border: 1px solid #e8efff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(64, 128, 255, 0.10);
    margin-bottom: 16px;
    min-height: 96px;
    overflow: hidden;
}

.today_panel_left {
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 280px;
    padding: 20px 28px;
    background: linear-gradient(135deg, #4080ff 0%, #73a7ff 100%);
    flex-shrink: 0;
}

.today_panel_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.22);
    color: #fff;
    flex-shrink: 0;
}

.today_panel_title,
.today_total_block,
.stat_card_info {
    display: flex;
    flex-direction: column;
}

.today_panel_title {
    gap: 4px;
}

.today_main_title {
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2;
}

.today_sub_title {
    color: rgba(255, 255, 255, 0.82);
    font-size: 13px;
}

.today_divider {
    width: 1px;
    height: 40px;
    margin: 0 4px;
    background: rgba(255, 255, 255, 0.30);
    flex-shrink: 0;
}

.today_total_block {
    align-items: center;
    gap: 2px;
}

.today_total_num {
    color: #fff;
    font-size: 32px;
    font-weight: 800;
    line-height: 1;
}

.today_total_label {
    color: rgba(255, 255, 255, 0.80);
    font-size: 12px;
    white-space: nowrap;
}

.today_panel_right {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 12px;
    min-width: 0;
    padding: 16px 24px;
    background: #f7faff;
    overflow-x: auto;
}

.stat_card {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 12px;
    min-width: 0;
    padding: 14px 16px;
    border: 1.5px solid transparent;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    transition: box-shadow 0.2s, transform 0.2s;
}

.stat_card:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.10);
    transform: translateY(-2px);
}

.stat_card_active {
    position: relative;
    border-color: var(--card-color);
    background: var(--card-color);
    box-shadow: 0 5px 16px rgba(31, 45, 61, 0.18);
    transform: translateY(-1px);
}

.stat_card_active::after {
    position: absolute;
    top: 8px;
    right: 9px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.92);
    content: '';
}

.stat_card_active .stat_card_icon {
    background: rgba(255, 255, 255, 0.22);
    color: #fff;
}

.stat_card_active .stat_num,
.stat_card_active .stat_label {
    color: #fff !important;
}

.stat_card_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border-radius: 9px;
    flex-shrink: 0;
}

.stat_card_info {
    gap: 2px;
    min-width: 0;
}

.stat_num {
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
}

.stat_label {
    color: #999;
    font-size: 11px;
    white-space: nowrap;
}

.stat_card_wait_sign { --card-color: #f07800; border-color: #fff3e6; }
.stat_card_wait_sign .stat_card_icon { background: #fff3e6; color: #f07800; }
.stat_card_wait_sign .stat_num { color: #f07800; }
.stat_card_total { --card-color: #4080ff; border-color: #e8efff; }
.stat_card_total .stat_card_icon { background: #e8efff; color: #4080ff; }
.stat_card_total .stat_num { color: #4080ff; }
.stat_card_wait_visit { --card-color: #1677ff; border-color: #e6f4ff; }
.stat_card_wait_visit .stat_card_icon { background: #e6f4ff; color: #1677ff; }
.stat_card_wait_visit .stat_num { color: #1677ff; }
.stat_card_visiting { --card-color: #00b96b; border-color: #e6fff0; }
.stat_card_visiting .stat_card_icon { background: #e6fff0; color: #00b96b; }
.stat_card_visiting .stat_num { color: #00b96b; }
.stat_card_done { --card-color: #4080ff; border-color: #f0f5ff; }
.stat_card_done .stat_card_icon { background: #f0f5ff; color: #4080ff; }
.stat_card_done .stat_num { color: #4080ff; }
.stat_card_cancel { --card-color: #cf1322; border-color: #fff1f0; }
.stat_card_cancel .stat_card_icon { background: #fff1f0; color: #cf1322; }
.stat_card_cancel .stat_num { color: #cf1322; }

@media (max-width: 1200px) {
    .today_panel_left {
        min-width: 280px;
        padding: 16px 20px;
    }

    .today_panel_right {
        gap: 8px;
        padding: 12px;
    }

    .stat_card {
        gap: 8px;
        padding: 12px 10px;
    }

    .stat_card_icon {
        width: 32px;
        height: 32px;
    }
}
</style>